import {
  FeatureFlag,
  checkFeatureFlag,
  useFeatureFlag,
} from './useFeatureFlag';

/**
 * Utility function to check if debug mode is enabled via query string (?debug=true)
 * Use this in non-React contexts (e.g., GoJS templates, utility functions)
 */
export const isDebugMode = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return checkFeatureFlag(FeatureFlag.RISK_DEBUG);
};

/**
 * Hook to check if debug mode is enabled via query string (?debug=true)
 * Use this in React components
 */
export const useDebugMode = (): boolean => {
  return useFeatureFlag(FeatureFlag.RISK_DEBUG);
};
